import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import formPassengersStore from 'entities/ticket/models/form-passengers/form-passengers-store'

import { TicketInsurance } from 'shared/api/avia/insurance'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Switch } from 'shared/ui/switch'

import s from './styles.module.scss'

interface Props {
  insurance: TicketInsurance
  onSelectInsurance: (insurance: TicketInsurance, value: boolean) => void
}

export const InsuranceServicesCard = observer(
  ({ insurance, onSelectInsurance }: Props) => {
    const { t } = useTranslation()

    const isSelectedInsurances = !!formPassengersStore.selectedInsurances?.find(
      (item) => item.name === insurance.name,
    )
    return (
      <div
        className={clsx(s.insuranceCard, isSelectedInsurances && s.bordered)}
      >
        <div className={s.insuranceHeader}>
          <p className={clsx('bold-18', s.insuranceCardTitle)}>
            {insurance.name}
          </p>
        </div>

        {insurance.content.map((item) => (
          <div className={s.insuranceParams}>
            <AppIcon
              id={AllIcons.CHECK_MARK}
              className={s.icon}
            />

            <div className={s.insuranceParamsText}>
              <p className={clsx('bold-14', s.insuranceParamsTitle)}>
                {item.title}
              </p>
              <p className={clsx('medium-14', s.insuranceParamsDescription)}>
                {item.description}
              </p>
            </div>
          </div>
        ))}

        <div className={s.insuranceDivider}></div>

        <div className={s.insuranceFooter}>
          <div className={s.leftCol}>
            <p className={clsx('medium-18', s.price)}>
              {priceShow(insurance.price)} &#8384;
            </p>
            <p className={clsx('regular-12', s.priceDescription)}>
              {t('insurance_info.for_all_passengers')}
            </p>
          </div>

          <Switch
            isChecked={isSelectedInsurances}
            onChange={(value) => onSelectInsurance(insurance, value)}
            isInsurance
          />
        </div>
      </div>
    )
  },
)
